import xss from 'xss'

import { Text } from '@wartek-id/text-v1'

import { nl2br, stripHTMLTags } from 'utils/text'

import type { FC } from 'react'

type BlockQuestionAnswerProps = {
  question: string
  answer: string
}

const BlockQuestionAnswer: FC<BlockQuestionAnswerProps> = ({
  question,
  answer,
}) => {
  return (
    <div className="space-y-2">
      <Text variant="action">{question}</Text>
      <Text
        variant="body"
        color="subdued"
        aria-label={`Answer for ${question}`}
        dangerouslySetInnerHTML={{
          __html: nl2br(stripHTMLTags(xss(answer))),
        }}
      />
    </div>
  )
}

export default BlockQuestionAnswer
